export const DOWNLOAD_TEXT = "Download image!";
